import Forgot from './Forgot';

export default Forgot;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Forgot/index.ts